<template>
    <AuthorPage :author="author" />
</template>

<script setup>
import AuthorPage from '~/components/author-page/author-page.vue'

const { author } = useRoute().params
</script>
